<script setup lang="ts">
import HeaderLogo from '@/components/icons/IconHeaderLogo.vue'
import IconLogin from '@/components/icons/IconLogin.vue'
import InformationIcon from '@/components/icons/informationBanner/InformationIcon.vue'

import { inject, onMounted } from 'vue';
import { type Config } from '@/types/config'
import InformationBanner from '@/components/InformationBanner.vue';
import { useInformationBannerStore } from '@/stores/informationBanner';
import { storeToRefs } from 'pinia';

const config = inject('config') as Config

const envVar: string = config.env
const policyHref: string = envVar.indexOf('.') == -1 ? `${envVar}policy.americanstrategic.com/Policy/Menu.aspx` : `https://policy${envVar}.americanstrategic.com/Policy/Menu.aspx`;
const portalHref: string = envVar.indexOf('.') == -1 ? `${envVar}portal.asipolicy.com` : `https://portal${envVar}.asipolicy.com`;

const { banners } = storeToRefs(useInformationBannerStore());

onMounted(() => {
    useInformationBannerStore().fetchInformationBanners();
});
</script>

<template>
    <div>
        <InformationBanner v-for="banner in banners" :severity="banner[1].severity"
            :labelled-by="`alert${banner[1].id}`" :key="banner[1].id">
            <template v-if="banner[1].icon != ''" #icon>
                <InformationIcon :name="banner[1].icon" />
            </template>
            <template #message><strong class="pe-2">{{ banner[1].name }}:</strong>
                <p class="d-inline">{{ banner[1].bannerText }}</p>
            </template>
        </InformationBanner>
        <header class="header-primary">
            <div class="row-head">
                <div class="container">
                    <div class="row">
                        <div class="col-5 col-sm-6 container-header-items">
                            <a href="/" class="container-header-logo">
                                <HeaderLogo />
                            </a>
                        </div>
                        <nav class="col-7 col-sm-6 nav navbar-expand container-login">
                            <div class="container-header-items">
                                <a href="tel:1-866-274-8765" aria-label="Call American Strategic Insurance Home"
                                    class="link-header-phone fw-bold d-sm-inline-block d-none">
                                    1-866-274-8765
                                </a>
                                <div class="navbar-nav navbar-nav-login ps-4">
                                    <div class="nav-item dropdown">
                                        <a class="nav-link fw-bold ml-auto dropdown-toggle dropdown-toggle-login"
                                            href="#" role="button" id="loginMenu" data-bs-toggle="dropdown"
                                            aria-haspopup="true" aria-expanded="false" aria-controls="loginMenuList">
                                            <IconLogin />
                                            Login
                                        </a>
                                        <ul id="loginMenuList"
                                            class="dropdown-menu dropdown-menu-end dropdown-menu-login"
                                            aria-labelledBy="loginMenu">
                                            <li><a class="dropdown-item" :href="portalHref">Policyholders</a></li>
                                            <li><a class="dropdown-item" :href="policyHref">Agents</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </header>
    </div>
</template>
